declare const jhsapp: any;

/**
 * 获取用户token
 * @returns {Promise<string | null>} 返回token字符串，如果没有token则返回null
 */
export const getToken = async (): Promise<string | null> => {
  try {
    // 测试环境返回一个测试token
    // if (__ENV__ === 'dev') {
    //   return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyNS0wNC0yNCAxOTowOTo0My4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvVG9reW8ifSwic3ViIjo0MTQ0ODMyLCJpc3MiOiJodHRwOi8vZ2Fvc2lqaWUuYXBpLWRldi50Y2djYXJkLmpwL2FwaS9tYXJrZXQvYXV0aC9hdXRoMC1zbnMtbG9naW4iLCJpYXQiOjE3NjQ1Njc0OTQsImV4cCI6MTc2OTc1MTQ5NCwibmJmIjoxNzY0NTY3NDk0LCJqdGkiOiI1U2lqd05kYjlybjg3R1VOIn0.0tVHaK2ae8ZbfTqeYez32LYmeILSgzvOcMLPR84GQNo';
    // }
    if (typeof window !== 'undefined' && window.jhsapp && typeof window.jhsapp.getToken === 'function') {
      const token = window.jhsapp.getToken();
      console.log('当前token', token);
      return token;
    }
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwic3ViIjo5Nzg4OTQsImlzcyI6Imh0dHBzOi8vYXBpLXRlc3RpbmcuamlodWFuc2hlLmNvbS9hcGkvbWFya2V0L2F1dGgvbG9naW4iLCJpYXQiOjE3NDcwNTM3NzEsImV4cCI6MTc1MjIzNzc3MSwibmJmIjoxNzQ3MDUzNzcxLCJqdGkiOiJVUlV6Mk9Kdmk5aHIwcGlrIn0.YQz9xYtGkFiX5BSS32FM2-mvHNCoF6MUtHcsUt-ZrXE';
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwic3ViIjo5MjkzMTIsImlzcyI6Imh0dHBzOi8vYXBpLXRlc3RpbmcuamlodWFuc2hlLmNvbS9hcGkvbWFya2V0L2F1dGgvbG9naW4iLCJpYXQiOjE3NDkxMDEwNDQsImV4cCI6MTc1NDI4NTA0NCwibmJmIjoxNzQ5MTAxMDQ0LCJqdGkiOiJ0dWtiNzg1WVR4SlA0UTFlIn0._zXtUdiGF2buaz_QH7rge0YS28Tshb370CBy7r8GAIU';
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyNS0wMy0xMCAxODoxOTo0Mi4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvU2hhbmdoYWkifSwic3ViIjoyMjY3MTU5LCJpc3MiOiJodHRwOi8vMTgwLjE4NC45My4yMDk6NDY4MzIvYXBpL21hcmtldC9hdXRoL2xvZ2luLW9yLXNpZ251cCIsImlhdCI6MTc0OTEwOTg2MSwiZXhwIjoxNzU0MjkzODYxLCJuYmYiOjE3NDkxMDk4NjEsImp0aSI6IkR3dEE3MFNNRmE4dWxTQXUifQ.-TANhyGq3ZzZNkuh1Dq9iC540fcmBYEnjIiJhRaHWFI'
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwic3ViIjo5NzkwMDMsImlzcyI6Imh0dHBzOi8vYXBpLXRlc3RpbmcuamlodWFuc2hlLmNvbSIsImlhdCI6MTc1MTk0OTgwMCwiZXhwIjoxNzU3MTMzODAwLCJuYmYiOjE3NTE5NDk4MDAsImp0aSI6IkhxUVRaNm1rQ1d6SFNvQ20ifQ._WHIAqKsznUhlKeW5uF_A4Rtmj2ly7qF5VI_W3c-2vA'
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyMy0wNS0xMiAxNzo1NjowNS4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvVG9reW8ifSwic3ViIjo5MjkzMTIsImlzcyI6Imh0dHA6Ly9hcGktZGV2LnRjZ2NhcmQuanAvYXBpL21hcmtldC9hdXRoL2xvZ2luIiwiaWF0IjoxNzU4ODY4MDAwLCJleHAiOjE3NjQwNTIwMDAsIm5iZiI6MTc1ODg2ODAwMCwianRpIjoiVW9VcnJHeFEwRVljS0twcCJ9.Wqon9mDXugL2L-jwpxn9-P-1HLFf1_wlURhqmYyeXYY'
    // return token;
    return null;
  } catch (error) {

    // console.error('获取token失败:', error);
    return null;
  }
};

/**
 * 检查用户是否为游客
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const isGuest = async (): Promise<boolean> => {
  // 测试环境直接返回false
  // if (__ENV__ === 'dev') {
  //   return false;
  // }
  try {
    const token = await getToken();
    return !token;
    // 调试时设为false
    // return false;
  } catch (error) {
    console.log('isGuest');
    // console.error('检查用户是否为游客失败:', error);
    return true;
  }
};

/**
 * 检查用户是否为游客，并跳转登录页面
 * @param next 跳转的回调函数
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const checkLoginAndGo = async (next: () => void): Promise<boolean> => {
  const guest = await isGuest();
  // console.log(guest, 'guest');
  if (guest) {
    // 国际环境
    const isInternational = __IS_WW__

    // 根据环境选择跳转官网链接
    const webUrl = isInternational ? 'https://kadoraba.com' : 'https://www.jihuanshe.com';

    if (typeof window !== 'undefined' && window.jhsapp && typeof window.jhsapp.router === 'function') {
      window.jhsapp.router("https://www.jihuanshe.com/app/login");
    } else {
      window.location.href = webUrl;
    }
    return false;
  }
  next();
  return true;
}